import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import {
  type BookingAppointmentsPostResponse,
  bookingAppointmentsPostResponse,
} from "../schemas/bookingAppointments";
import { bookingAppointmentInput } from "../schemas/bookingAppointments.input";

export const createBookingAppointmentProps = z
  .object({ appointment: bookingAppointmentInput, bookingMarket: z.string() })
  .extend(requestConfig.shape);

export type CreateBookingAppointmentProps = z.infer<
  typeof createBookingAppointmentProps
>;

export const createBookingAppointment = async (
  args: CreateBookingAppointmentProps,
): Promise<BookingAppointmentsPostResponse["outcome"]> => {
  const {
    appointment,
    endpoint = env.ACCOUNT_SERVICE_URL,
    proxyAuthSecret,
    bookingMarket,
  } = parseServiceInput(createBookingAppointmentProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    // no token necessary for Booking endpoints
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const params = new URLSearchParams({
    bookingMarket,
  });

  const response = await fetch(
    `${endpoint}/v1/bookings/appointments?${params.toString()}`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(appointment),
    },
  );

  const data = await parseServiceOutput(
    response,
    bookingAppointmentsPostResponse,
    {
      code: "MALFORMED_APPOINTMENT",
      message: "Issue creating appointment",
    },
  );
  return data.outcome;
};
